import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Video, Brain, Grid3x3, User, Settings, Crown, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { motion } from 'framer-motion';

export const Sidebar = () => {
  const location = useLocation();
  const { user, logout } = useAuth();

  const menuItems = [
    { icon: Home, label: 'Início', path: '/dashboard' },
    { icon: Video, label: 'Vídeos', path: '/videos' },
    { icon: Brain, label: 'Quiz', path: '/quiz' },
    { icon: Grid3x3, label: 'Caça-Palavras', path: '/caca-palavras' },
    { icon: User, label: 'Meu Perfil', path: '/perfil' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <motion.div
      initial={{ x: -264 }}
      animate={{ x: 0 }}
      className="hidden md:flex flex-col w-64 h-screen fixed left-0 top-0 border-r border-border bg-white p-6 z-40"
    >
      <div className="flex items-center gap-3 mb-8">
        <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-primary to-secondary flex items-center justify-center text-white font-bold text-lg">
          BC
        </div>
        <div>
          <h1 className="text-xl font-bold" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Beto Carvalho
          </h1>
          <p className="text-xs text-muted-foreground">Conhecimentos Gerais</p>
        </div>
      </div>

      {user && user.plan === 'PREMIUM' && (
        <div className="mb-6 p-4 rounded-xl bg-gradient-to-br from-primary/10 to-secondary/10 border border-primary/20">
          <div className="flex items-center gap-2 mb-1">
            <Crown className="h-4 w-4 text-primary" />
            <span className="font-semibold text-sm">Plano Premium</span>
          </div>
          <p className="text-xs text-muted-foreground">Acesso total ao conteúdo</p>
        </div>
      )}

      <nav className="flex-1 space-y-2">
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            data-testid={`sidebar-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
            className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${
              isActive(item.path)
                ? 'bg-primary text-white shadow-lg shadow-primary/20'
                : 'text-foreground hover:bg-muted'
            }`}
          >
            <item.icon className="h-5 w-5" />
            <span className="font-medium">{item.label}</span>
          </Link>
        ))}

        {user && user.plan !== 'PREMIUM' && (
          <Link
            to="/upgrade"
            data-testid="sidebar-upgrade"
            className="flex items-center gap-3 px-4 py-3 rounded-xl bg-gradient-to-r from-primary to-secondary text-white hover:opacity-90 transition-opacity mt-4"
          >
            <Crown className="h-5 w-5" />
            <span className="font-medium">Upgrade Premium</span>
          </Link>
        )}
      </nav>

      <div className="border-t border-border pt-4 space-y-2">
        <Link
          to="/configuracoes"
          data-testid="sidebar-settings"
          className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${
            isActive('/configuracoes')
              ? 'bg-primary text-white'
              : 'text-foreground hover:bg-muted'
          }`}
        >
          <Settings className="h-5 w-5" />
          <span className="font-medium">Configurações</span>
        </Link>
        <button
          onClick={logout}
          data-testid="sidebar-logout"
          className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-red-600 hover:bg-red-50 transition-all"
        >
          <LogOut className="h-5 w-5" />
          <span className="font-medium">Sair</span>
        </button>
      </div>
    </motion.div>
  );
};
